<template>
  <div class="products-container">
    <nav-bar></nav-bar>
    <div class="container second-container">
      <div class="columns is-vcentered custom-vertical-space">
        <div class="column is-12"></div>
      </div>
      <div class="columns">
        <div class="column is-10-fullhd is-offset-1-fullhd products-title">
          <div class="content">
            <h1 class="is-uppercase has-text-centered has-text-primary">
              {{ texts.pageTitle }}
            </h1>
          </div>
        </div>
      </div>
      <div class="column is-12-fullhd">
        <div class="columns">
          <!-- <div class="column is-three-quarters products-title"> -->
          <div class="column  products-title " style="padding-top: 5rem;">
            <div class="content">
              <p v-html="texts.paragraph1"></p>
              <p v-if="isExpanded" v-html="texts.paragraph2"></p>
              <p v-if="isExpanded" v-html="texts.paragraph3"></p>
              <p v-if="isExpanded" v-html="texts.paragraph4"></p>
              <p v-if="isExpanded" v-html="texts.paragraph5"></p>
              <p v-if="isExpanded" class="has-text-weight-bold">{{ texts.fourthRow }}</p>
            </div>
          </div>

          <ProductCategories></ProductCategories>

        </div>
      </div>
    </div>

    <div class="container second-container">
      <div class="columns is-vcentered custom-vertical-space">
        <div class="column is-12 has-text-centered">
          <img v-if="isMobileView" class="arrow" :src="arrowImgSrc" width="12px" heigth="14px" alt="arrow"
            @click="expandDescription" />
        </div>
      </div>
    </div>

    <div class="container second-container ">
      <div class="columns is-multiline" style="padding: 0 11% 50px 11%">
        <div class="product-card products extraOptions column is-12-mobile is-6-tablet is-4-desktop"
          v-for="(product, index) in products" :key="index">
          <h3 class="productName has-text-weight-bold is-centered mb-5">
            {{ texts.products[product.model] }}
          </h3>

          <div class="cardContent">
            <div class="card-details" style="justify-content: space-between;">
              <div class="card-details-inner ">
                <div class="cardData price">
                  <!--<div class="cardLabel">
                    <img class="detailLogo" src="../assets/images/products/ar.svg" alt="" />
                    <div class="detailLabel">{{ textsGeneral.price }}</div>
                  </div>
                   <div class="detailValue has-text-weight-bold mr-3" :class="product.newPrice && product.newPrice < product.price
                    ? 'oldPrice'
                    : ''
                    ">
                    <p>€ {{ product.price }}<span></span></p>
                  </div>
                  <div v-if="product.newPrice && product.newPrice < product.price"
                    class="detailValue newPrice has-text-weight-bold">
                    € {{ product.newPrice }}
                  </div> -->
                </div>
              </div>
              <button class="button is-rounded is-outlined is-primary is-uppercase has-text-weight-bold" style="margin: 0"
                @click="getSelectedProduct(product)">
                {{ textsGeneral.askOffer }}
              </button>
            </div>
            <div class="card-image-container">
              <figure class="image is-1by1">
                <img class="card-image" :src="`${publicPath}${product.img}`" :alt="product.imgAlt" />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </div>
</template>
<script>
import NavBar from "./Navbar.vue";
import AppFooter from "./AppFooter.vue";
import ProductCategories from "./ProductCategories.vue";
import extraOptions from "../assets/extraOptions";


export default {
  data() {
    return {
      products: extraOptions,
      currentPage: 1,
      publicPath: process.env.BASE_URL,
      index: null,
      currentOffset: 0,
      dragging: false,
      isDescriptionExpanded: false,
      doubleArrowDown: require("../assets/images/double_arrow_down.svg"),
      doubleArrowUp: require("../assets/images/double_arrow_up.svg"),
    };
  },
  created() {
    let url_string = window.location.href; //window.location.href
    let url = new URL(url_string);
    let setParameterInUrl = url.searchParams.get("set");
    if (this.getSetParameterFromUrl() == null) {
      this.currentPage = 1;
    } else {
      this.currentPage = Number(this.getSetParameterFromUrl());
    }
  },
  components: {
    NavBar: NavBar,
    AppFooter: AppFooter,
    ProductCategories: ProductCategories
  },
  computed: {
    texts() {
      return this.$t("products.extraOptions");
    },
    textsGeneral() {
      return this.$t("products.general");
    },
    introTexts() {
      return this.$t("homePage");
    },
    isMobileView: {
      get() {
        if (window.innerWidth < 768) {
          return true;
        } else {
          return false;
        }
      },
    },
    arrowImgSrc: {
      get() {
        if (this.isExpanded) {
          return this.doubleArrowUp;
        } else {
          return this.doubleArrowDown;
        }
      },
    },
    isExpanded() {
      if (!this.isMobileView) {
        return true;
      } else {
        if (this.isDescriptionExpanded) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.setCurrentPage(to.query["set"]);
    next();
  },
  methods: {
    setCurrentPage(parameter) {
      let page = 1;
      if (parameter != null) {
        page = parseInt(parameter, 10);
      }
      this.currentPage = page;
    },
    getSetParameterFromUrl() {
      let url_string = window.location.href; //window.location.href
      let url = new URL(url_string);
      return url.searchParams.get("set");
    },
    expandDescription() {
      console.log("click a nyilra");
      if (this.isDescriptionExpanded == false) {
        this.isDescriptionExpanded = true;
      } else {
        this.isDescriptionExpanded = false;
      }
    },
    getSelectedProduct(selectedProduct) {
      this.$store.dispatch("saveSelectedProduct", selectedProduct);
      this.$router.replace("/" + this.$i18n.locale + "/contact");
    },
  },
  mounted() {
    this.$watch("$refs.carousel.currentOffset", function (new_value) {
      this.$data.currentOffset = -new_value;
      this.$data.dragging = this.$refs.carousel.dragging;
    });
    // this.unorderedList = this.$t("products.mobilehouse.ul");
  },
};
</script>
<style lang="scss" scoped>
.carousel-header {
  position: relative;
  z-index: 1000;
  background-color: white;
}

.card {
  border: 1px solid #266e79;
  border-bottom: 0px;
}

.card-content {
  text-align: center;
  padding: 0;

  h3 {
    padding-bottom: 10%;
    color: #00323d;
    border-bottom: 1px solid #266e79;
  }

  p {
    border-bottom: 1px solid #266e79;
    color: #00323d;
  }
}

.card .image img {
  padding: 25px;
}

.orange {
  color: #e56a25;
}

.products-anchor:hover {
  img {
    transform-origin: center 58%;
    transition: 0.3s ease-out;
    transform: scale(1.02);
  }
}

.products-anchor {
  img {
    transition: 0.3s ease-out;
  }

  .image {
    padding: 8% 0;
  }

  .image img {
    min-width: 128px;
    max-width: 75%;
  }
}

.image p {
  position: absolute;
  right: 0;
  left: 0;
  text-align: center;
  color: #fff;
  z-index: 35;
  transition: 0.3s ease-out;
  text-transform: uppercase;
  font-size: 0.7em;
  max-width: 80%;
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);
}

.products-container .description2 {
  margin: 7.5rem auto 2rem;
}

@include mobile {
  .image {
    display: flex;

    img {
      margin: 0 auto;
    }
  }

  .card-content h3 {
    padding-bottom: 3%;
  }
}

.subtitleWithLogo {
  justify-content: center;
  align-items: center;
  margin-top: 2rem;

  .customSubtitle {
    line-height: 2.5rem;
    margin: 0 0 0 1rem;
    font-style: none;
  }

  img {
    height: 1.9rem;
    width: auto;
  }

  @media (max-width: 600px) {
    align-items: center;
    flex-direction: column;

    .customSubtitle {
      margin: 0 1rem 0 0;
    }
  }
}

.subtitleWithLogo .content .customSubtitle {
  margin-top: 0;
}

.additionalComponent {
  margin-bottom: 1rem;
}

.additionalComponent.orange {
  margin-bottom: 0.6rem;
}

.productsPaginationContainer {
  padding-top: 5rem;
  margin-bottom: 3rem;
}

.arrow {
  width: 30px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .products-container .description2 {
    margin: 1rem auto 2rem;
    padding: 0 35px;
  }

  .productsPaginationContainer {
    padding-top: 3rem;
    margin-bottom: 3rem;
  }
}

.product-card.products.extraOptions {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 12px 0;

  .productName {
    font-size: 1.4rem;
  }

  .cardContent {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    border-radius: 16px;

    .card-details {
      width: 100%;
      border-top: none;
      border-left: 3px solid rgba(61, 120, 130, 0.2);
      border-bottom: 3px solid rgba(61, 120, 130, 0.2);
      border-right: 3px solid rgba(61, 120, 130, 0.2);
      border-bottom-left-radius: 1rem;
      border-top-left-radius: 0;
      border-bottom-right-radius: 1rem;
      width: 100%;
      padding: 1.6rem;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -ms-flex-pack: distribute;
      justify-content: space-around;
      -webkit-box-align: start;
      -ms-flex-align: start;
      align-items: start;
      -webkit-box-ordinal-group: 3;
      -ms-flex-order: 2;
      order: 2;
      min-height: unset;

      .card-details-inner  {
        .cardData.price {
          .cardLabel {
            width: 200px;
          }
          .detailValue  {
            width: 60px;
          }
        }
      }
    }

    .card-image-container {
      width: 100%;

      .card-image {
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 0;
        border-top-left-radius: 1rem;
      }
    }
  }
}

.image-wrapper {
    position: relative;
    display: inline-block;
    width: 128px;
    height: 128px;
  }

  .image-wrapper img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  .image-wrapper::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .image-wrapper.orange::after {
    background: rgba(229, 106, 37, 0.8); /* Dark semi-transparent overlay */

  }

  .image-wrapper.dark-blue::after {
    background: rgba(0, 50, 61, 0.8); /* Dark semi-transparent overlay */

  }

  .image-wrapper.light-blue::after {
    background: rgba(30, 110, 122, 0.8); /* Dark semi-transparent overlay */

  }
</style>
